<template>
    <div>
        <v-autocomplete
            v-model="winbizService.syncParams[0].value"
            :items="folders.map(folder => folder.dos_name)"
            :label="this.$t('FolderName')"
            clearable
            @blur="loadWinbizFiscalYears"
            @input="loadWinbizFiscalYears"
        ></v-autocomplete>
        <v-select
            v-model="winbizService.syncParams[1].value"
            :items="fiscalYears"
            :label="this.$t('Site.ConnectedService.Winbiz.FiscalYears')"
            multiple
            :disabled="fiscalYears.length === 0"
        ></v-select>
    </div>
</template>
<script>
import ConnectedServiceService from '@/services/ConnectedServiceService';
import Utils from '@/ecm/common/Utils';
export default {
    name: 'WinbizControls',
    data() {
        return {
            fiscalYears: [],
            folders: []
        };
    },
    props: {
        winbizService: {
            type: Object,
            required: true
        }
    },
    created() {
        this.loadWinbizFolders();
    },
    methods: {
        loadWinbizFolders() {
            this.$emit('loading', true);
            ConnectedServiceService.getWinbizFolders(this.winbizService.id)
                .then(winbizFolders => {
                    this.folders = winbizFolders;
                })
                .catch(() => {
                    Utils.toast.error(this.$t('Site.ConnectedService.Winbiz.GetFoldersError'));
                })
                .then(() => {
                    this.$emit('loading', false);
                });
        },
        loadWinbizFiscalYears() {
            this.fiscalYears = [];
            const selectedFolder = this.folders.find(folder => folder.dos_name === this.winbizService.syncParams[0].value);
            if (!selectedFolder) return;
            selectedFolder.exercices.forEach(exercise => this.fiscalYears.push(exercise.exc_annee));
        }
    }
};
</script>